const recentSearch = (router) => {
    console.log("router.query ** autoSuggest", router);
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(router)
    };
    return fetch(`activity/api/recentSearch`,requestOptions).then((response) => response.json())
}
export default recentSearch;